import { createSelector } from '@reduxjs/toolkit';
import {
    selectActivitiesFromSearchState,
    selectIsEmptyActivitiesAfterFiltered,
    selectResultInfoFromSearchState,
    selectSearchState,
} from 'component/page/search/store/search.selectors';
import { activityCardMapper } from 'component/common/ActivityCard/ActivityCard.selectors';
import { BootstrapConfig } from 'core/type/BootstrapConfig.types';
import { selectConfigFromBootstrap, selectFeatureBehaviorFromBootstrap } from 'store/slice/bootstrap';
import { selectSearchBoxSettingsTravelDate } from 'store/slice/home';
import { selectNavigationState, selectSearchPageType } from 'store/slice/navigation';
import { isCityPage } from 'core/constant/analytics/AnalyticsPageType';
import { ActivityCardProps } from 'core/type/ActivityCard.types';
import { SearchPageType } from 'store/slice/slice.types';

interface StateProps {
    isLoading: boolean;
    isSuccess: boolean;
    forceNavigateToFirstPage: boolean;
    isCityPage: boolean;
    config: BootstrapConfig;
    activitiesList: ActivityCardProps[];
    travelDate?: Date;
    isSearchBoxFeatureGroup: boolean;
    shouldShowCityNameOnCard: boolean;
}

export type ActivityListProps = StateProps;

export const mapStateToProps = createSelector(
    selectSearchState,
    selectActivitiesFromSearchState,
    selectResultInfoFromSearchState,
    selectConfigFromBootstrap,
    selectIsEmptyActivitiesAfterFiltered,
    selectSearchBoxSettingsTravelDate,
    selectNavigationState,
    selectSearchPageType,
    selectFeatureBehaviorFromBootstrap,
    (state, activities, resultInfo, config, forceNavigateToFirstPage, travelDate, navigationState, searchPageType, featureBehaviours): StateProps => {
        if (state.isLoading) {
            return {
                activitiesList: [],
                config,
                forceNavigateToFirstPage,
                isLoading: state.isLoading,
                isSuccess: state.isSuccess,
                isCityPage: false,
                isSearchBoxFeatureGroup: featureBehaviours.SearchBoxFeatureGroup,
                shouldShowCityNameOnCard: false,
            };
        }
        const isGlobalKeywordSearchPage = featureBehaviours.GlobalKeywordSearch && searchPageType === SearchPageType.TextSearch;
        const activitiesList = activityCardMapper(activities, config, resultInfo, state.filter, travelDate, isGlobalKeywordSearchPage);
        return {
            activitiesList,
            config,
            forceNavigateToFirstPage,
            travelDate,
            isLoading: state.isLoading,
            isSuccess: state.isSuccess,
            isCityPage: isCityPage(navigationState.pageTypeId),
            isSearchBoxFeatureGroup: featureBehaviours.SearchBoxFeatureGroup,
            shouldShowCityNameOnCard: isGlobalKeywordSearchPage,
        };
    },
);
